module.exports = __webpack_public_path__ + "static/media/area-chart.a066da64.svg";